export default __webpack_public_path__ + "static/cards2-c85d93a128ae00aab736e8b7ca247769.png";